export namespace LLMConstants {
    export const StaticValueVariablePrefix = "__static";
    export const AmdValueVariablePrefix = "__amd";
    export const StructuredOutputVariableName = "structured_output";
    export const ExtendedMetadataVariableName = "extended_metadata";
    export const MLModelsVariableName = "ml_models";
    export const ExtendedMetadataFullyQualifiedName =
        AmdValueVariablePrefix + "." + ExtendedMetadataVariableName;
    export const MLModelsFullyQualifiedName =
        AmdValueVariablePrefix + "." + MLModelsVariableName;
    export const LLMModelsVariableName = "llm_models";
    export const LLMModelsFullyQualifiedName =
        AmdValueVariablePrefix + "." + LLMModelsVariableName;

    export const ContactTypeMLModelFullyQualifiedName =
        MLModelsFullyQualifiedName + ".ContactType";
    export const SummaryMLModelFullyQualifiedName =
        MLModelsFullyQualifiedName + ".Summary";
    export const VoicemailMLModelFullyQualifiedName =
        MLModelsFullyQualifiedName + ".Voicemail";
    export const IvrMLModelFullyQualifiedName =
        MLModelsFullyQualifiedName + ".IVR";
    export const EddyEffectMLModelFullyQualifiedName =
        MLModelsFullyQualifiedName + ".EddyEffect";
    export const HipaaMLModelFullyQualifiedName =
        MLModelsFullyQualifiedName + ".HIPAA";
    export const AdverseEventMLModelFullyQualifiedName =
        MLModelsFullyQualifiedName + ".ML-AdverseEvents";
    export const AdverseEventP2MLModelFullyQualifiedName =
        MLModelsFullyQualifiedName + ".ML-AdverseEvents-P2";
    export const SafetyEventIdentifiedMLModelFullyQualifiedName =
        MLModelsFullyQualifiedName + ".SafetyEventIdentified";
    export const SafetyEventAcknowledgedMLModelFullyQualifiedName =
        MLModelsFullyQualifiedName + ".SafetyEventAcknowledged";
    export const SentimentBeginningMLModelFullyQualifiedName =
        MLModelsFullyQualifiedName + ".SentimentBeginning";
    export const SentimentEndingMLModelFullyQualifiedName =
        MLModelsFullyQualifiedName + ".SentimentEnding";
    export const TopicLLMModelFullyQualifiedName =
        MLModelsFullyQualifiedName + ".TopicLLM";
}
